{
  "responseShape": "Respons pelayan tidak sepadan dengan format yang dijangka — sila muat semula.",
  "badRequest": "Permintaan tidak sah. Sila semak input anda.",
  "forbidden": "Anda tidak mempunyai kebenaran untuk melakukan tindakan ini.",
  "facilityRequired": "Pilih fasiliti di pengepala untuk menggunakan modul ini.",
  "notFound": "Sumber tidak ditemui.",
  "conflict": "Sumber sudah wujud.",
  "validation": "Ralat pengesahan.",
  "tooManyRequests": "Terlalu banyak permintaan. Sila cuba lagi kemudian.",
  "serverError": "Ralat pelayan. Sila cuba lagi kemudian.",
  "unexpected": "Ralat tidak dijangka berlaku.",
  "network": "Ralat rangkaian. Sila semak sambungan anda.",
  "requestSetup": "Ralat berlaku. Sila cuba lagi.",
  "sessionExpired": "Sesi anda telah tamat. Sila log masuk semula."
}
